import { Component, HostListener } from '@angular/core';
import { Dotcom2024Service } from '../dotcom2024.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule, MapGeocoder } from '@angular/google-maps';
import { parse } from 'path';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-locations',
  standalone: true,
  imports: [CommonModule, FormsModule, GoogleMapsModule],
  templateUrl: './locations.component.html',
  styleUrl: './locations.component.css'
})



export class LocationsComponent {
  //in case the user clicks the back button after filtering 
  //for this to work there is code in the onInit section -- seach on "in case the"
  // @HostListener('window:popstate', ['$event'])
  // onPopState(event: Event): void {
  //   window.location.reload();
  // }


  constructor(public myHarrellsService: MyharrellsService, public router: Router, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public geocoder: MapGeocoder) {
    this.gc = geocoder;
    geocoder.geocode({
      address: '1600 Amphitheatre Parkway, Mountain View, CA'
    }).subscribe(({ results }) => {
      // console.log(results);
    });

  }

  gc: MapGeocoder;

  nzLocations: any[] = [];

  // MAPS OBJECTS FOR ALTERNATE LOCATIONS
  // maps used alternate locations
  options: google.maps.MapOptions = {
    mapId: "DEMO_MAP_ID",
    center: { lat: -31, lng: 147 },
    zoom: 4,
  };
  // markers used alternate locations
  altLocationsMarkers: any[] = [];
  // END - MAPS OBJECTS FOR ALTERNATE LOCATIONS

  // MAPS OBJECTS FOR DEFAULT LOCATION
  // map used as the locations
  optionsDefMap: google.maps.MapOptions = {
    mapId: "Default_MAP_ID",
    center: { lat: -31, lng: 147 },
    zoom: 4,
  };
  // markers used default location
  defMarker: any[] = [];
  // END - MAPS OBJECTS FOR DEFAULT LOCATION

  headerImageToUse: string = 'locations-header.jpg'; //default 
  defWarehouse: any = {};
  haveDefLocationImages: boolean = false
  haveAltLocationImages: boolean = false
  warehousesAll: any[] = [];
  warehouseToDisplay: number = 0;
  warehousesInDistanceOrder: any[] = [];
  usersLocationdetected: boolean = false;
  zipCode: string = "";
  displayFailure: boolean = false;
  failureText: string = "";

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Locations/";
  employeePhotosImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Employee-Photos/";

  ngOnInit(): void {


      //in case the user hits the back button - this will reset the URL to the locations page because it adds a new history entry in browser
      //for this to work there is code in the top of this file -- seach on "in case the"
      // window.history.pushState({}, 'Locations', '/locations');


    this.dotComService.activePage = "locations"

    //meta tags for SEO
    this.title.setTitle("Harrell’s Locations | Warehouses & Blend Plants Nationwide");
    this.meta.updateTag({ name: 'description', content: "Harrell’s operates fertilizer blend plants and warehouses across the U.S. Find a location near you and access our agronomic solutions today." });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s Locations | Warehouses & Blend Plants Nationwide" });
    this.meta.updateTag({ property: 'og:description', content: "Harrell’s operates fertilizer blend plants and warehouses across the U.S. Find a location near you and access our agronomic solutions today." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - locations" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - locations" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s Locations | Warehouses & Blend Plants Nationwide" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s Locations | Warehouses & Blend Plants Nationwide" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s Locations | Warehouses & Blend Plants Nationwide" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Harrell’s operates fertilizer blend plants and warehouses across the U.S. Find a location near you and access our agronomic solutions today." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - locations" });


    // this.dotComService.GetLocations().then(results => {
    //   //this.GetDefLocation();

    this.warehousesAll = JSON.parse(sessionStorage.getItem('warehouses'));

    //query strings come in submenu and used to make the selected location active on the page 
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);

      let filter = urlParams.get('filter');

      if (filter && filter != "") {
        let selectedWhse = this.warehousesAll.filter(x => x.name == filter)
        this.GetLocationFromWhseGraph(selectedWhse[0].zip.substring(0, 5));
      }


      // this.GetLocationFromWhseGraph(filter);

    }


    // })
  }

  GetDefLocation() {
    this.warehousesInDistanceOrder = [];
    //detect users location and use that as the default location - if cant detect with location services (browser config) user is prompted to enter zip code
    navigator.geolocation.getCurrentPosition((position) => {
      this.usersLocationdetected = true;
      this.GetDefLocation2(position.coords.latitude, position.coords.longitude);
    }
      , (error) => {
        // console.log("geolocation did not work - user has not allowed location services");
        this.displayFailure = true;
        this.failureText = "We were unable to determine your location so all warehouses have been displayed. Please ensure your browser's location services are enabled.  Alternatively, you can enter your zip code manually to find the closest warehouse to you.";
        this.usersLocationdetected = false;
      }
    );
  }

  GetDefLocation2(defaultLat: number, defaultLon: number) {
    //called from 2 places, 
    //one is the default location because location services picked it up and the other is the location from the zip code that user keyed in

    let data = this.warehousesAll; //this.dotComService.warehouses;
    let closest = 0;
    let closestDistance = 0;
    this.warehousesInDistanceOrder = [];
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      data[index].lat = parseFloat(element.latitude);
      data[index].lon = parseFloat(element.longitude);
      //this calcs the distance between two points using their lat and long
      //DOES NOT USE GOOGLE MAPS API TO DO THIS - THIS IS A SIMPLE CALCULATION USING THE HAVERSINE FORMULA (ALL MATH GIVEN THE RADIOUS OF THE EARTH)
      //THIS DISTANCE IS MILES AS THE CROW FLIES - NOT DRIVING DISTANCE
      let distance = this.dotComService.CalculateDistance(defaultLat, defaultLon, parseFloat(element.latitude), parseFloat(element.longitude));
      this.warehousesInDistanceOrder.push({ distance: distance, warehouse: element });
      if (index == 0) {
        closest = index;
        closestDistance = distance;
      } else {
        if (distance < closestDistance) {
          closest = index;
          closestDistance = distance;
        }
      }
    }
    this.defWarehouse = data[closest];
    //assign this locations image as the header image  - turned off for now until sam gets better images 5/12
    this.headerImageToUse = 'locations-header.jpg' //this.defWarehouse.city + "-Main.jpg"; 
    this.optionsDefMap = {
      mapId: "Default_MAP_ID",
      center: { lat: parseFloat(this.defWarehouse.latitude), lng: parseFloat(this.defWarehouse.longitude) },
      zoom: 10,
    };
    this.defMarker = [
      { lat: parseFloat(this.defWarehouse.latitude), lng: parseFloat(this.defWarehouse.longitude) }
    ];
    this.warehousesInDistanceOrder.sort((a, b) => (a.distance > b.distance) ? 1 : -1);
    this.warehousesInDistanceOrder = this.warehousesInDistanceOrder.slice(1, 4); //index 0 is the default location so we skip it

    //check to see if we have the images for this location.  some do and some dont 
    this.dotComService.checkIfImageExists(this.pageImagePaths + this.defWarehouse.city + "-Left.jpg", (exists) => {
      if (exists) {
        this.haveDefLocationImages = true;
      }
      else {
        this.haveDefLocationImages = false;
      }
    });

    //check to see if the main image exists, if not use the default image
    this.dotComService.checkIfImageExists(this.pageImagePaths + this.defWarehouse.city + "-Main.jpg", (exists) => {
      if (exists) { }
      else {
        this.headerImageToUse = 'locations-header.jpg';
      }
    });

  }

  ToggleExpand(warehouse: any) {
    if (this.warehouseToDisplay == warehouse.Id) {
      this.warehouseToDisplay = 0;
    } else {
      this.warehouseToDisplay = warehouse.Id;
      //map data
      this.options = {
        mapId: "DEMO_MAP_ID",
        center: { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) },
        zoom: 10,
      };
      //map pin data -- you can have multiple pins if you add more objects to the altLocationsMarkers array
      this.altLocationsMarkers = [
        { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) }
      ];

      //check to see if we have the images for this location.  some do and some dont 
      this.dotComService.checkIfImageExists(this.pageImagePaths + warehouse.city + "-Left.jpg", (exists) => {
        if (exists) {
          this.haveAltLocationImages = true;
        }
        else {
          this.haveAltLocationImages = false;
        }
      });



    }
  }

  ToggleExpandAllWarehouses(warehouse: any) {
    if (this.warehouseToDisplay == warehouse.Id) {
      this.warehouseToDisplay = 0;
    } else {
      this.warehouseToDisplay = warehouse.Id;
      //map data
      this.options = {
        mapId: "DEMO_MAP_ID",
        center: { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) },
        zoom: 10,
      };
      //map pin data -- you can have multiple pins if you add more objects to the nzLocations array
      this.nzLocations = [
        { lat: parseFloat(warehouse.latitude), lng: parseFloat(warehouse.longitude) }
      ];
      //get the employee info to dislay the photos and hover displays name and title
      this.dotComService.GetEmployees('GetSiteServiceEmployees', warehouse.Id, 0).subscribe(data => {
        warehouse.employees = data;
        for (let index = 0; index < warehouse.employees.length; index++) {
          const element = warehouse.employees[index];
          //check to see if the image exists as a jpg, if not use png and then if neiter exist the html will show a default image
          this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".jpg", (exists) => {
            if (exists) {
              // Success code
              //this.dotComService.resourceFilteredPosts[i].ImageName = this.blogImagePaths + this.dotComService.resourceFilteredPosts[i].ItemAlias + ".jpg"
              element.empPhoto = this.employeePhotosImagePaths + element.Id + ".jpg";
            } else {
              // Fail code
              this.dotComService.checkIfImageExists(this.employeePhotosImagePaths + element.Id + ".png", (exists) => {
                if (exists) {
                  // Success code
                  element.empPhoto = this.employeePhotosImagePaths + element.Id + ".png";
                } else {
                  // Fail code - use default
                  element.empPhoto = this.baseImagePaths + "harrellsh.png"
                }
              })
            }
          });
        }
      });
    }
  }

  GetDirections(warehouse: any) {
    window.open("https://www.google.com/maps/dir//" + warehouse.address + ", " + warehouse.city + ", " + warehouse.state + " " + warehouse.zip, "_blank");
  }

  GetLocationFromWhseGraph(zip: string) {
    this.zipCode = zip.substring(0, 5);
    this.GetLocationFromZip();
    window.scrollTo(0, 0);
  }

  GetLocationFromZip() {
    this.displayFailure = false;
    if (this.zipCode.length != 5) {
      // alert("Please enter a valid 5 digit zip code");
      this.failureText = "Please enter a valid 5 digit zip code";
      this.displayFailure = true;
      this.usersLocationdetected = false;
    } else {




      this.dotComService.zipCodeEntered = this.zipCode;
      this.dotComService.GetLatLonFromZip().subscribe(data => {

        if (data.results.length > 0) {
          this.GetDefLocation2(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);
          this.usersLocationdetected = true;
          this.displayFailure = false;
          this.failureText = "";
        }
        else {
          this.failureText = "Zip code not found. Please try again.";
          this.displayFailure = true;
        }
      });
    }
  }

  HideFailureAlert() {
    this.displayFailure = false;
  }

  ViewAllWarehouses() {
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['/locations'])
    // });
    this.usersLocationdetected = false;
    this.zipCode = "";
    location.href = '/locations';
  }

}
